// ==============================|| OVERRIDES - CHECKBOX ||============================== //

export default function MenuItem(theme) {
  return {
    MuiMenuItem: {
      styleOverrides: {
        root: {
          borderRadius: "1em",
          border: "1px solid black",
          margin: "1em",
          overflow: "hidden",
          "&:hover": {
            opacity: "0.8",
          },
          "&.Mui-selected": {
            backgroundColor: `${theme.palette.primary["dark"]} !important`,
            color: theme.palette.common.white,
          },
        },
      },
    },
  }
}
